import "./App.css";
import CategoriesPage from "./pages/CategoriesPage";
import Header from "./components/Header";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router";
import ListPage from "./pages/ListPage";
import ItemPage from "./pages/ItemPage";
import ErrorBoundary from "./ErrorBoundary";
import NotFoundPage from "./pages/NotFoundPage";
import ErrorElement from "./ErrorElement";
import { createTheme, ThemeProvider } from "@mui/material";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";
//routes
const router = createBrowserRouter([
  { path: "/user/login", element: <LoginPage /> },
  { path: "/", element: <Navigate to="/category" replace /> },
  {
    path: "/category",
    element: (
      <ProtectedRoute>
        <Header>
          <CategoriesPage />
        </Header>
      </ProtectedRoute>
    ),
  },
  {
    path: "/list/:id",
    element: (
      <ProtectedRoute>
        <Header>
          <ListPage />
        </Header>
      </ProtectedRoute>
    ),
    errorElement: <ErrorElement />,
  },
  {
    path: "/item/:id",
    element: (
      <ProtectedRoute>
        <Header>
          <ItemPage />
        </Header>
      </ProtectedRoute>
    ),
    errorElement: <ErrorElement />,
  },
  { path: "*", element: <NotFoundPage /> },
]);

function App() {
  const darkTheme = createTheme({
    palette: {
      mode: "dark",
    },
  });
  return (
    <ErrorBoundary>
      <ThemeProvider theme={darkTheme}>
        <div className="App">
          <div className="App-content">
            <RouterProvider router={router} />
          </div>
        </div>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
